// Shared helpers for HR tab components. Kept as a single small module so
// HR.jsx and its child panels don't drift on formatting rules.
export const fmt$ = (n) =>
  `$${Number(n || 0).toLocaleString("en-US", { maximumFractionDigits: 0 })}`;

export const dayLabel = (l) => {
  const d = l.days_requested || 0;
  return Number.isInteger(d) ? String(d) : d.toFixed(1);
};

export function BalancePill({ balance, type }) {
  if (!balance || !balance[type]) return null;
  const b = balance[type];
  const critical = b.left <= 0;
  const warn = b.left <= 3;
  const cls = critical
    ? "bg-red-50 text-[#D0021B] border-[#D0021B]"
    : warn
    ? "bg-amber-50 text-amber-700 border-amber-300"
    : "bg-emerald-50 text-emerald-700 border-emerald-300";
  return (
    <span
      className={`inline-block text-[10px] font-mono border px-1.5 py-0.5 mr-1 ${cls}`}
      data-testid={`balance-${type}`}
    >
      {type.toUpperCase()} · {b.left}/{b.entitlement}d LEFT
    </span>
  );
}
